document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initCountUp();
  initMarquesina();
  initGaleria();
  setTimeout(function () {
    document.querySelectorAll('.hg-reveal:not(.hg-visible), .hg-reveal-scale:not(.hg-visible)').forEach(function (el) {
      el.classList.add('hg-visible');
    });
  }, 2000);
});

function initGaleria() {
  document.querySelectorAll('[data-hg-galeria]').forEach(function (galeria) {
    galeria.querySelectorAll('[data-hg-mini]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.hgMini;
        galeria.querySelectorAll('[data-hg-img]').forEach(function (img) {
          img.hidden = img.dataset.hgImg !== id;
        });
        galeria.querySelectorAll('[data-hg-mini]').forEach(function (b) { b.classList.remove('hg-activo'); });
        btn.classList.add('hg-activo');
      });
    });
  });
}

function initReveals() {
  var els = document.querySelectorAll('.hg-reveal, .hg-reveal-scale');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.dataset.hgDelay || 0;
        setTimeout(function () { entry.target.classList.add('hg-visible'); }, parseInt(delay, 10));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-hg-count]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.dataset.hgCount);
      var suffix = el.dataset.hgSuffix || '';
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(eased * target) + suffix;
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target + suffix;
      }
      requestAnimationFrame(step);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesina() {
  document.querySelectorAll('[data-hg-marquesina]').forEach(function (track) {
    if (track.dataset.hgInit) return;
    track.dataset.hgInit = '1';
    track.innerHTML += track.innerHTML;
  });
}
